export enum Order {
  Descending = 'desc',
  Ascending = 'asc',
}

export enum OrderBy {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at',
}
